export default {
  allUsers: 'Wszyscy użytkownicy',
  zeroUsers: 'Wybrano 0 użytkowników',
  users: 'użytkownicy',
};
